<template>
  <div class="is-marginless is-paddingless section section-logo">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('catalogue.productType.title') }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <a @click="$router.push({name: 'l.bodac.catalogue-produitAchat'})"
               class="button btn-modal-annuler is-cancel ">
              {{ $t('general.button.cancel') }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <div v-for="section in sections" :key="section.code">
      <div v-if="getFilteredProduit(section.code).length > 0">
        <p class="mgt-40px mgb-20px is-size-6 has-text-link has-text-weight-bold">
          {{ $t(section.title) }}
        </p>
        <div class="link-box-container">
          <router-link
            v-for="produit in getFilteredProduit(section.code)"
            :key="produit.code"
            class="link-box"
            :to="{ name: produit.route, params: { isFromCatalogueAchat:  produit.routeParams } }"
            :class="{'text-access-no-permission' : !checkPermissions(permCatalogue.maj)}">
              <div class="logo">
                <div :class="produit.logo"/>
              </div>
              <p class="has-text-weight-bold is-size-4 has-text-centered">
                {{ $t(produit.libelle) }}
              </p>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import AppBreadcrumb from '@/components/general/breadcrumb';
import inProgress from '@/services/general/inProgress';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import {
  CATEGORIE_DIVERS,
  CATEGORIE_IMPRESSION_AFFICHE,
} from '@/configuration/catalogue/produitConf';
import messageErreur from '@/services/general/messageErreur';

const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');
const CategorieVente = createNamespacedHelpers('categorieVente');

export default {
  data() {
    return {
      permCatalogue: CATALOGUE,
      sections: [
        { title: 'catalogue.productType.achat', code: 'achat' },
      ],
    };
  },
  components: {
    AppBreadcrumb,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...CategorieVente.mapGetters({
      categorieProduitByCode: 'categorieProduitAchatByCode',
    }),
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('catalogue.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeProduitAchat.breadcrumb.liste'), route: { name: 'l.bodac.catalogue-produitAchat' }, isActive: false },
        { title: this.$i18n.t('catalogue.productType.breadcrumb'), route: { name: 'm.bodac.catalogue-typeCreationAchat' }, isActive: true },
      ];
      return output;
    },
    produits() {
      return [
        {
          code: CATEGORIE_DIVERS,
          route: 'm.bodac.catalogue-nouveauDivers',
          routeParams: true,
          libelle: 'catalogue.productType.various',
          logo: 'logo__divers',
          section: 'achat',
        },
        {
          code: CATEGORIE_IMPRESSION_AFFICHE,
          route: 'm.bodac.catalogue-nouveauProduitImpressionAffiche',
          routeParams: true,
          libelle: 'catalogue.productType.impressionAffiche',
          logo: 'logo__divers',
          section: 'achat',
        },
      ];
    },
  },
  methods: {
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    getFilteredProduit(sectionName) {
      return this.produits.filter(p => {
        return p.section === sectionName
          && this.categorieProduitByCode.includes(p.code);
      });
    },
  },
  mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.setInformationPage(this.$t('pageGescom.produit.creation'));
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
